import React, {useState, useEffect, useRef, useContext} from 'react'
import UserContext from '../../context/context'
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { history } from '../../_helpers';
import { nationOptios,tagOptions, fieldOptions, kindofcompanyOptions } from '../SignIn/data';
import Select from 'react-select';

import DaumPostcode from 'react-daum-postcode';

import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

function ComInfoPost(){
  const [state, actions] = useContext(UserContext);
  // const [ra, setRa] = useState()
  // const [applicant, setApplicant] = useState()
  // const [viewers, setViewers] = useState()
  // const [which, setWhich] = useState()
  
  const [companyInfo, setCompanyInfo] = useState()

  const [edit, setEdit] = useState(false)

  const [title, setTitle] = useState()
  const [intro, setIntro] = useState()
  const [address, setAddress] = useState()
  const [postcode, setPostcode] = useState()
  const [addressDetail, setAddressDetail] = useState('')
  
  const [homepage, setHomepage] = useState()
  const [tag, setTag] = useState([])

  const [nation, setNation] = useState()
  const [year, setYear] = useState() //From here, need to add models.py and edit views.py
  const [field, setField] = useState()
  const [comNumber, setComNumber] = useState()
  const [revenue, setRevenue] = useState()
  const [investment, setInvestment] = useState()
  const [people, setPeople] = useState()
  const [phone, setPhone] = useState()
  const [ceo, setCeo] = useState()
  const [product, setProduct] = useState()
  const [whichkind, setWhichkind] = useState()
  
  const [isOpenPost, setIsOpenPost] = useState(false);

  
  const inputFile = useRef(null) 
  const [selectedFile, setSelectedFile] = useState();
	const [isFilePicked, setIsFilePicked] = useState(false);

  const inputFileMain = useRef(null) 
  const [selectedFileMain, setSelectedFileMain] = useState();
	const [isFilePickedMain, setIsFilePickedMain] = useState(false);

  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const [editorToHtml, setEditorToHtml] = useState(EditorState.createEmpty())

  
  const [imglogo, setImglogo] = useState(state.noimage)
  const [imgmain, setImgmain] = useState(state.noimage)


  const onEditorStateChange = (editorState) => {
    // editorState에 값 설정
    setEditorState(editorState);
  };

  let user = JSON.parse(String(localStorage.getItem('user')))
  let email = String(localStorage.getItem('email'))
  const header = {Authorization: `JWT ${user.token}`}


  let current_status = history.location.pathname.split('/')[3]
  // console.log(history.location.pathname.split('/')[3])

  // let apilink = ''

  // if(localStorage.getItem("is_headhunter") === "true") {apilink = "/api/rahh/";}
  // else if (localStorage.getItem("is_recruiter") === "true") {apilink = "/api/ra/";}


  function fetchCompanyInfoPut(){
    let smethod = ''
    if(companyInfo){
      fetch(state.awslink + "/user/company/", {
        method: 'PUT',
        headers: header,
        body:JSON.stringify({
          "id": companyInfo.id,
          "title": title || null,
          "intro": JSON.stringify(convertToRaw(editorState.getCurrentContent())) || null,
          "address": address || null,
          "addressDetail": addressDetail || null,
          "homepage": homepage || null,
          "tag": tag || null,
          "nation": nation || null,
          "comNumber": comNumber || null,
          "revenue": revenue || null,
          "investment": investment || null,
          "people": people || null,
          "phone": phone || null,
          "field": field || null,
          "year": year || null,
          "ceo": ceo || null,
          "product": product || null,
          "whichkind": whichkind || null,
        })
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        let parsed = EditorState.createWithContent(editorState.getCurrentContent())
        setEditorToHtml(draftToHtml(convertToRaw(parsed.getCurrentContent())))
      })
    } else{
      fetch(state.awslink + "/user/company/", {
        method: 'POST',
        headers: header,
        body:JSON.stringify({
          "title": title || null,
          "intro": JSON.stringify(convertToRaw(editorState.getCurrentContent())) || null,
          "address": address || null,
          "addressDetail": addressDetail || null,
          "homepage": homepage || null,
          "tag": tag || null,
          "nation": nation || null,
          "comNumber": comNumber || null,
          "revenue": revenue || null,
          "investment": investment || null,
          "people": people || null,
          "phone": phone || null,
          "field": field || null,
          "year": year || null,
          "ceo": ceo || null,
          "product": product || null,
          "whichkind": whichkind || null,
        })
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        let parsed = EditorState.createWithContent(editorState.getCurrentContent())
        setEditorToHtml(draftToHtml(convertToRaw(parsed.getCurrentContent())))
      })
    }
  }
  


  useEffect(()=>{
    async function fetchCompanyInfo(){
      const res =  fetch(state.awslink + "/user/company/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setField(json.field)
        setTag(json.tag)
        setNation(json.nation)

        setCompanyInfo(json)
        setTitle(json.title)

        if(json.intro){
          let parsed = EditorState.createWithContent(convertFromRaw(JSON.parse(json.intro))) 
          // console.log(draftToHtml(convertToRaw(parsed.getCurrentContent())))
          //get
          setEditorToHtml(draftToHtml(convertToRaw(parsed.getCurrentContent())))
          //put
          setEditorState(parsed)

        }
        // setIntro(json.intro)

        setAddress(json.address)
        setAddressDetail(json.addressDetail)
        setHomepage(json.homepage)
        
        setYear(json.year)
        setComNumber(json.comNumber)
        setRevenue(json.revenue)
        setInvestment(json.investment)
        setPeople(json.people)
        setPhone(json.phone)
        setCeo(json.ceo)
        setProduct(json.product)
        setWhichkind(json.whichkind)

        setImglogo(json.user.logolink + "?dummy=000")
        setImgmain(json.user.mainlink + "?dummy=000")
      })
    }

    fetchCompanyInfo();

    
  }, [])

  const handleChange = (nameTag) => e => {
    // if(nameTag === "ab") setAbilities(Array.isArray(e) ? e.map(x => x.value) : []);
    // else if(nameTag === "int") setInterests(Array.isArray(e) ? e.map(x => x.value) : []);
    if(nameTag === "tag") setTag(Array.isArray(e) ? e.map(x => x.value) : []);
  }
  
  function handleDefault(index) {

    let tempObj=[];

    index.map((item)=>{tempObj.push({value:item, label:item})})
    return(tempObj)
  }

  const onCompletePost = (data) => {
    let fullAddr = data.address;
    let extraAddr = '';

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddr += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddr += extraAddr !== '' ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddr += extraAddr !== '' ? ` (${extraAddr})` : '';
    }

    setAddress(fullAddr);
    setPostcode(data.zonecode);
    setIsOpenPost(false);
  };



  const changeHandler = (event, whichimg) => {
    if(whichimg === "logo"){
      setSelectedFile(event.target.files[0]);
      setIsFilePicked(true);
    }
    else{
      setSelectedFileMain(event.target.files[0]);
      setIsFilePickedMain(true);
    }
    handleSubmission(event.target.files[0], whichimg)

	};

  const handleSubmission = (file, whichimg) => {
		const formData = new FormData();
    // console.log(whichimg)
    // if(whichimg === "logo")
		//   formData.append('file', selectedFile,  whichimg + '.' + selectedFile.name.split('.')[selectedFile.name.split('.').length-1]);
    // else
    //   formData.append('file', selectedFileMain,  whichimg + '.' + selectedFileMain.name.split('.')[selectedFileMain.name.split('.').length-1]);

    formData.append('file', file,  whichimg + '.' + file.name.split('.')[file.name.split('.').length-1]);  
		
    fetch(
			state.awslink + "/api/file/?" + whichimg + "=true",
			{
				method: 'POST',
        headers: header,
				body: formData,
			}
		)
			.then((response) => response.json())
			.then((result) => {
				console.log('Success:', result);
        // setSelectedFile()
        // window.location.reload()
        if(whichimg === "main") 
          setImgmain(result.file + "?dummy=101112")
        else  
          setImglogo(result.file + "?dummy=101112")
        setIsFilePicked()
        setIsFilePickedMain()
			})
			.catch((error) => {
				console.error('Error:', error);
			});
    
	};
  const onButtonClick = (whichimg) => {
    // `current` points to the mounted file input element
    if(whichimg === "logo")
      inputFile.current.click();
    else
      inputFileMain.current.click();
   
  };

  // console.log(ra, applicant, viewers)

  
  // console.log("field", fieldOptions.filter((item)=>item.value===field))
  // console.log("nation", nationOptios.filter((item)=>item.value===nation))
  console.log(companyInfo, field
    ,nation
    ,tag
    ,whichkind)
  return(
    <>
    {/* {state.width < state.breakpoint ? 
      null
    : */}
      <Wrapper>
        <RaWrapper>
          {isOpenPost?
          <DaumPostcode autoClose onComplete={onCompletePost }/>
          : null}
          
          {companyInfo&&field&&nation&&tag&&whichkind ?
            current_status !== "edit" ?
              <ProfileForm>
                <ContentForm>
                <Link to={"/recruiter/companyinfo/edit"}>EDIT</Link>
                <div >
                  <h4>
                    사진
                  </h4>
                  <div className={"cominfo-photo"}>
                    <ImgWrapper>
                      <img 
                        src = {imglogo? imglogo + "?dummy=123": "dummy"} 
                        onError={(e)=> {
                            e.target.src = state.noimage
                        }}
                        />
                      <div>로고</div>
                    </ImgWrapper>
                    <ImgWrapper>
                      <img 
                        src = {imgmain? imgmain + "?dummy=123": "dummy"} 
                        onError={(e)=> {
                            e.target.src = state.noimage
                        }}
                      />
                      <div>메인</div>
                    </ImgWrapper>
                  </div>
                </div>


                <span>
                  <div>
                    <h4>회사명</h4>
                    <div>{title}</div>
                  </div>
                  <div>
                    <h4>대표이사</h4>
                    <div>{ceo}</div>
                  </div>
                </span>

                <span>
                  <div>
                    <h4>주소</h4>
                    <div>{address} {addressDetail}</div>
                  </div>

                  <div>
                    <h4>국가</h4>
                    <div>{nation}</div>
                  </div>
                  
                </span>

                <span>
                  <div>
                    <h4>직군</h4>
                    <div>{field}</div>
                  </div>
                  <div>
                    <h4>회사형태</h4>
                    <div>{whichkind}</div>
                  </div>
                  
                </span>
                
                
                <span>
                  <div>
                    <h4>매출</h4>
                    <div>{revenue}</div>
                  </div>
                  <div>
                    <h4>누적투자금</h4>
                    <div>{investment}</div>
                  </div>
                </span>

                <span>
                  <div>
                    <h4>사업자등록번호</h4>
                    <div>{comNumber}</div>
                  </div>
                  <div>
                    <h4>주요제품/서비스</h4>
                    <div>{product}</div>
                  </div>
                </span>

                <span>
                  <div>
                    <h4>임직원수</h4>
                    <div>{people}</div>
                  </div>
                  <div>
                    <h4>전화번호</h4>
                    <div>{phone}</div>
                  </div>
                </span>

                <span>
                  <div>
                    <h4>창립년도</h4>
                    <div>{year}</div>
                  </div>
                  <div>
                    <h4>홈페이지</h4>
                    <div>{homepage}</div>
                  </div>
                </span>

                <span>
                  <div>
                    <h4>태그</h4>
                    <div className={"ras-tag"}>
                      {tag.map((item)=>{
                        return(
                          <div>{item}</div>
                        )
                      })}
                    </div>
                  </div>
                </span>

                
                <div>
                  <h4>회사소개</h4>
                  <div>
                    
                    <ContentWrapper>
                      <div dangerouslySetInnerHTML={{__html: editorToHtml}}/>  
                    </ContentWrapper>
                  </div>
                </div>
                </ContentForm>
              </ProfileForm>
              :
              <ProfileForm>
                <ContentForm>

                <div >
                  <h4>
                    사진
                  </h4>
                  <div className={"cominfo-photo"}>
                    <ImgWrapper>
                      <img 
                        src = {imglogo? imglogo + "?dummy=1232": "dummy"} 
                        onError={(e)=> {
                            e.target.src = state.noimage
                        }}
                        onClick={()=>onButtonClick("logo")}
                        style={{cursor: "pointer" }}
                      />
                      <input 
                        type="file" 
                        name="file" 
                        ref={inputFile} 
                        onChange={(e)=>{changeHandler(e, "logo"); console.log("onChange")}} 
                        style={{ display: "none" }}/>
                      <div>로고</div>
                    </ImgWrapper>

                    <ImgWrapper>
                      <img 
                        src = {imgmain ? imgmain + "?dummy=1232424" : "dummy"} 
                        onError={(e)=> {
                          e.target.src = state.noimage
                        }}
                        onClick={()=>onButtonClick("main")}
                        style={{cursor: "pointer" }}
                      />
                      <input 
                        type="file" 
                        name="file" 
                        ref={inputFileMain} 
                        onChange={(e)=>{changeHandler(e, "main"); console.log("onChange")}} 
                        style={{ display: "none" }}/>
                      <div>메인</div>
                    </ImgWrapper>

                  </div>
                </div>

                <span>
                  <div>
                    <h4>회사명</h4>
                    <div>
                    <input className="basic-input" value={title} onChange={(e)=>setTitle(e.target.value)}/>
                    </div>
                  </div>
                  <div>
                    <h4>대표이사</h4>
                    <div>
                    <input className="basic-input" value={ceo} onChange={(e)=>setCeo(e.target.value)}/>
                    </div>
                  </div>
                </span>

                <span>
                  <div>
                    <h4>주소</h4>
                    <div>
                    <input onClick={()=>setIsOpenPost(true)} className="basic-input" value={address}/>
                    <input className="basic-input" value={addressDetail} onChange={(e)=>setAddressDetail(e.target.value)}/>
                    </div>
                  </div>

                  <div>
                    <h4>국가</h4>
                    <div>
                    <Select
                      className="basic-single"
                      defaultValue={nationOptios.filter((item)=>item.value===nation)}
                      isSearchable={true}
                      name="color"
                      options={nationOptios}
                      onChange={(e)=>{if(e.value) setNation(e.value)}}
                    /></div>
                  </div>
                </span>


                <span>
                  <div>
                    <h4>직군</h4>
                    <div>
                      <Select
                      className="basic-single"
                      defaultValue={fieldOptions.filter((item)=>item.value===field)}
                      isSearchable={true}
                      name="color"
                      options={fieldOptions}
                      onChange={(e)=>{if(e.value) setField(e.value)}}
                    /></div>
                  </div>
                  <div>
                    <h4>회사형태</h4>
                    <div>
                      <Select
                      className="basic-single"
                      defaultValue={kindofcompanyOptions.filter((item)=>item.value===whichkind)}
                      isSearchable={true}
                      name="color"
                      options={kindofcompanyOptions}
                      onChange={(e)=>{if(e.value) setWhichkind(e.value)}}
                    /></div>
                  </div>
                  
                </span>

                <span>
                  <div>
                    <h4>매출</h4>
                    <div>
                      <input className="basic-input" value={revenue} onChange={(e)=>setRevenue(e.target.value)}/>
                    </div>
                  </div>
                  <div>
                    <h4>누적투자금</h4>
                    <div>
                      <input className="basic-input" value={investment} onChange={(e)=>setInvestment(e.target.value)}/>
                    </div>
                  </div>
                </span>

                <span>
                  <div>
                    <h4>사업자등록번호</h4>
                    <div>
                      <input className="basic-input" value={comNumber} onChange={(e)=>setComNumber(e.target.value)}/>
                      </div>
                  </div>
                  <div>
                    <h4>주요제품/서비스</h4>
                    <div>
                    <input className="basic-input" value={product} onChange={(e)=>setProduct(e.target.value)}/>
                    </div>
                  </div>
                </span>

                <span>
                  <div>
                    <h4>임직원수</h4>
                    <div>
                      <input className="basic-input" value={people} onChange={(e)=>setPeople(e.target.value)}/>
                      </div>
                  </div>
                  <div>
                    <h4>전화번호</h4>
                    <div>
                      <input className="basic-input" value={phone} onChange={(e)=>setPhone(e.target.value)}/>
                    </div>
                  </div>
                </span>

                <span>
                  <div>
                    <h4>창립년도</h4>
                    <div>
                      <input className="basic-input" value={year} onChange={(e)=>setYear(e.target.value)}/>
                    </div>
                  </div>
                  <div>
                    <h4>홈페이지</h4>
                    <div>
                      <input className="basic-input" value={homepage} onChange={(e)=>setHomepage(e.target.value)}/>
                    </div>
                  </div>
                </span>

                <span>
                  <div>
                    <h4>태그</h4>
                    <div>
                      <Select
                        defaultValue={handleDefault(tag)}
                        className="basic-multi"
                        isMulti
                        options={tagOptions}
                        onChange={handleChange("tag")}
                      />
                    </div>
                  </div>
                </span>

                
                <div>
                  <h4>
                    내용
                  </h4>
                  <div>
                    <MyBlock>
                      <Editor
                        wrapperClassName="wrapper-class"
                        editorClassName="editor"
                        toolbarClassName="toolbar-class"
                        toolbar={{
                          list: { inDropdown: false },
                          textAlign: { inDropdown: false },
                          link: { inDropdown: true },
                          history: { inDropdown: false },
                        }} 
                        placeholder="내용을 작성해주세요."
                        localization={{locale: 'ko',}}
                        editorState={editorState}
                        onEditorStateChange={onEditorStateChange}
                      />
                    </MyBlock>
                  </div>
                </div>
                
                <div className={"addra-btn"}>
                  <button onClick={()=>{fetchCompanyInfoPut(); setEdit(!edit)}}>저장</button>
                </div>
                
                </ContentForm>
              </ProfileForm>
            
          : null
            
          }
          
          
          
        </RaWrapper>
      </Wrapper>   
    </>
  )
}


const IntroduceContent = styled.div`
  position: relative;
  border: 0.0625rem solid #d7e2eb;
  border-radius: 0.75rem;
  overflow: hidden;
  padding: 1.5rem;
  width: 50%;
  margin: 0 auto;
  margin-bottom: 4rem;
`;

const ContentWrapper = styled.div`
  display: block;
  /* margin-bottom: 20px; */
  >div{
    box-sizing: border-box;
    text-align: left;
    /* padding: 20px; */
    
  }
`


const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 50px);
  margin-top: 20px;
  display: block;
  position: relative;
`

const RaWrapper = styled.div`
  max-width: 1060px;
  width: 90%;
  display: flex;
  margin: 0 auto;
  background-color: whitesmoke;
  flex-direction: column;
`


const ProfileForm = styled.div`
  width: 100%;
  box-sizing: border-box;
  /* padding: 5px; */
  padding-left: 0px;
  display: flex;
  margin: 0;
  /* flex-wrap: nowrap; */
  text-align: left;
  vertical-align: top;

  /* min-height: 300px; */

`

const ContentForm = styled.div`
    width: 100%;
    position: relative;
    display: block;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    box-sizing: border-box;
    padding: 10px;
    padding-left: 30px;
    padding-right: 30px;

    background-color: rgba(255, 255, 255, 1);
    border-radius: 5px;
    border: .5px solid rgba(0,0,0,0.2);

    .addra-btn{
      display: flex;
      justify-content: flex-end;
      button{
        cursor: pointer;
        margin: 0;
        margin-bottom: 10px;
        width: 150px;
        height: 45px;
        border-radius: 10px;
        background-color: rgba(253,134,18,0.8);
        border: none;
        color: white;
        font-weight: bold;
        font-size: 1.1rem;  

        transition: .2s;
        :hover{
          background-color: rgba(253,134,18, 0.9);
        }
        :active{
          background-color: rgba(253,134,18, 1);
        }
      }
    }

    >span{
      margin-bottom: 20px;
      display: block;
      >div{
        display: inline-block;
        width: 50%;
        vertical-align: top;
        h4{
          margin: 0;
          padding-top: 20px;
          padding-bottom: 10px;
        }
        
        >div{
          
          font-size: 0.9rem;
          .basic-single{width: 200px;}
          .basic-multi{width: 200px;}
        }
        .ras-tag{
          >div{
            display: inline-block;
            font-size: 0.8rem;
            border: .5px solid rgba(0,0,0,0.2);
            border-radius: 12px;
            padding: 7px;
            padding-left: 10px;
            padding-right: 10px;
            margin: 5px;
            margin-left: 0;
            margin-right: 10px;
          }
        }
      }

    }

    >div{
      margin-bottom: 20px;
      h4{
        margin: 0;
        padding-top: 20px;
        padding-bottom: 10px;
      }
      >div{
        /* padding-left: 40px; */
        font-size: 0.9rem;
        .basic-single{
          width: 200px;
        }

        .basic-multi{
          width: 200px;
        }

        
      }
      .ras-tag{
        >div{
          display: inline-block;
          font-size: 0.8rem;
          border: .5px solid rgba(0,0,0,0.2);
          border-radius: 12px;
          padding: 7px;
          padding-left: 10px;
          padding-right: 10px;
          margin: 5px;
          margin-left: 0;
          margin-right: 10px;
        }
      }

      .cominfo-photo{
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 0px;
      }
      
    }
`
const MyBlock = styled.div`
  /* margin-top: 100px; */
  .wrapper-class{
      width: 100%;
      margin: 0 auto;
      margin-bottom: 4rem;
  }
  .editor {
    height: 500px !important;
    border: 1px solid rgba(0,0,0,0.2) !important;
    padding: 5px !important;
    border-radius: 2px !important;
    background-color: white;
  }
  .rdw-editor-toolbar{
    border: 1px solid rgba(0,0,0,0.2) !important;
  }
  .rdw-dropdown-wrapper{
    /* z-index: 1; */
  }

  .rdw-text-align-dropdown{
    z-index: 0;
  }
  .rdw-list-dropdown{
    z-index: 0;
  }
  .DraftEditor-editorContainer{
    z-index: 0;
  }
`;

const ImgWrapper=styled.div`
  
  display: inline-flex;
  width: 300px;
  height: 250px;
  flex-direction: column;
  position: relative;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  >img{
    object-fit: scale-down;
    max-width: 100%;
    height: 220px;
  }
  >div{
    bottom: 0;
    font-size: 0.9rem;
    opacity: .8;

    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    
  }

`

export default ComInfoPost